/**
 * JSON.parse a value only when it is a string; pass through objects/arrays and
 * non-JSON strings unchanged.
 *
 * @param {*} value
 * @returns {*} the parsed value, or the original value if it is not a JSON string
 */
export const parseMaybeJson = (value) => {
  if (typeof value !== 'string') return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
